import React from 'react';
import Page500View from 'src/views/errors/Page500View';

class ErrorComponentBoundry extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    // You can also log error messages to an error reporting service here
  }

  render() {
    if (this.state.errorInfo) {
      // Error path
      return <Page500View />;
    }
    // Normally, just render children
    return this.props.children;
  }
}

export default ErrorComponentBoundry;
